"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Mobile = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Mobile"));
var _Desktop = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Desktop"));
var _AirplaneUp3 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/AirplaneUp"));
var _CarRental2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/CarRental"));
var _Accommodation2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Accommodation"));
var _Trip2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Trip"));
var _StarFull2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/StarFull"));
var _Deals2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Deals"));
var _ChevronDown2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronDown"));
var _ChevronUp2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ChevronUp"));
var _Popover = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Popover"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _Link = _interopRequireDefault(require("./components/Link"));
var _context = require("../../services/intl/context");
var _context2 = require("../../services/brand/context");
var _jsxRuntime = require("react/jsx-runtime");
var _AirplaneUp, _FormattedMessage, _CarRental, _FormattedMessage2, _Accommodation, _FormattedMessage3, _Trip, _FormattedMessage4, _StarFull, _FormattedMessage5, _Deals, _FormattedMessage6, _AirplaneUp2, _ChevronUp, _ChevronDown;
const Links = ({
  active
}) => {
  const brand = (0, _context2.useBrand)();
  const {
    language
  } = (0, _context.useIntl)();
  const languageId = language.id;
  const travelLink = `/${languageId}/`;
  /**
   * - The following link doesn't use the brand's domain since it redirects to Kiwi.com anyway
   * - Special case for Greek language
   */
  const carsLink = `https://cars.kiwi.com?preflang=${languageId === "el" ? "gr" : languageId}&adplat=headerlinks`;

  /**
   * The following link doesn't use the brand's domain since it redirects to Kiwi.com anyway
   */
  const getStoriesUrl = () => {
    const storiesUrl = `https://www.kiwi.com/stories/`;
    // Languages that need to be replaced, based on the specs provided
    // in the Jira ticket: https://kiwicom.atlassian.net/browse/FEPLT-1234
    const supportedStoriesLanguages = {
      cz: "cs",
      sk: "cs",
      hu: "hu",
      pl: "pl",
      ro: "ro",
      es: "es"
    };
    if (supportedStoriesLanguages[languageId]) {
      return `${storiesUrl}${supportedStoriesLanguages[languageId]}/`;
    }
    return storiesUrl;
  };
  const storiesUrl = getStoriesUrl();

  /**
   * The following link doesn't use the brand's domain since it redirects to Kiwi.com anyway
   */
  const travelHacksUrl = `https://www.kiwi.com/${languageId}/cheap-flights/travel-hacks/`;

  /**
   * The following link might make use of the brand's domain since it's available for brands too.
   * TODO: check whether it makes sense for branded domains to use their domain instead of www.kiwi.com
   */
  const getDealsUrl = () => {
    // We might need to extend the logic a little bit to allow for "smarter"
    // URLs based off the previous deals page that was visited, if that's the case.
    return `https://www.kiwi.com/${languageId}/deals/?pageName=dealsMain&dealsProvider=cheapest`;
  };
  const dealsUrl = getDealsUrl();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    dataTest: "HeaderLinks",
    flex: true,
    direction: "column",
    desktop: {
      direction: "row",
      spacing: "medium"
    },
    spacing: "XXSmall",
    children: [brand.services.travel.enabled === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      link: travelLink,
      active: active === "travel",
      icon: _AirplaneUp || (_AirplaneUp = /*#__PURE__*/(0, _jsxRuntime.jsx)(_AirplaneUp3.default, {})),
      children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "search.service.travel_anywhere"
      }))
    }) : null, brand.services.rental_cars.enabled === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      link: carsLink,
      active: active === "cars",
      icon: _CarRental || (_CarRental = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CarRental2.default, {})),
      rel: "nofollow",
      external: true,
      children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "search.service.cars"
      }))
    }) : null, brand.services.accommodation.enabled === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      link: "https://rooms.kiwi.com/?label=pagenavtab-link-1549681-click",
      active: active === "rooms",
      icon: _Accommodation || (_Accommodation = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accommodation2.default, {})),
      rel: "nofollow",
      external: true,
      children: _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "search.service.rooms"
      }))
    }) : null, brand.services.stories.enabled === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      link: storiesUrl,
      active: active === "stories",
      icon: _Trip || (_Trip = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Trip2.default, {})),
      external: true,
      children: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "content.stories"
      }))
    }) : null, brand.services.travel_hacks.enabled === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      link: travelHacksUrl,
      active: active === "travelHacks",
      icon: _StarFull || (_StarFull = /*#__PURE__*/(0, _jsxRuntime.jsx)(_StarFull2.default, {})),
      children: _FormattedMessage5 || (_FormattedMessage5 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "pages.common.travel_hacks"
      }))
    }) : null, brand.services.deals.enabled === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      link: dealsUrl,
      active: active === "deals",
      icon: _Deals || (_Deals = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Deals2.default, {})),
      rel: "nofollow",
      children: _FormattedMessage6 || (_FormattedMessage6 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "search.service.deals"
      }))
    }) : null]
  });
};
const linkIcons = {
  travel: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AirplaneUp3.default, {}),
  cars: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CarRental2.default, {}),
  rooms: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accommodation2.default, {}),
  stories: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Trip2.default, {}),
  travelHacks: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StarFull2.default, {}),
  deals: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Deals2.default, {})
};
const HeaderLinks = ({
  active
}) => {
  var _ref;
  const brand = (0, _context2.useBrand)();
  const [isOpened, setOpened] = _react.default.useState(false);
  const intl = (0, _reactIntl.useIntl)();

  /**
   * If all links were disabled in the brand config, we don't render anything.
   */
  if ([brand.services.travel.enabled, brand.services.rental_cars.enabled, brand.services.accommodation.enabled, brand.services.stories.enabled, brand.services.travel_hacks.enabled, brand.services.deals.enabled].every(enabledLink => enabledLink === false)) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Mobile.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popover.default, {
        onOpen: () => setOpened(true),
        onClose: () => setOpened(false),
        content: /*#__PURE__*/(0, _jsxRuntime.jsx)(Links, {
          active: active
        }),
        width: "230px",
        labelClose: intl.formatMessage({
          id: "orbit.button_close"
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ButtonLink.default, {
          compact: true,
          type: "secondary",
          ariaLabelledby: "open",
          children: [(_ref = active && linkIcons[active]) !== null && _ref !== void 0 ? _ref : _AirplaneUp2 || (_AirplaneUp2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_AirplaneUp3.default, {})), isOpened ? _ChevronUp || (_ChevronUp = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronUp2.default, {
            size: "small"
          })) : _ChevronDown || (_ChevronDown = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronDown2.default, {
            size: "small"
          }))]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Desktop.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Links, {
        active: active
      })
    })]
  });
};
var _default = HeaderLinks;
exports.default = _default;